/* globals bd */
define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.metroContext = function () {

        // @ngInject
        /**
         * @param {ng.IHttpService} $http
         * @param {ng.ILogService} $log
         * @param {ng.IQService} $q
         */
        this.$get = function ($http, $log, $q, lpCoreUtils) {

            var config = {
                userValidateEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/users/$(userId)/validate/$(companyId)')
            };

            var cachedSession = null;

            function getSession() {
                if (!cachedSession) {
                    cachedSession = JSON.parse(localStorage.getItem('session'));
                }
                return cachedSession;
            }

            function isValid(sess) {
                return !bd.designMode || sess.status === 'VERIFIED';
            }

            function hasValidContext() {
                var session = getSession();
                if (session && isValid(session)) {
                    return true;
                }

                $log.log('Cannot make request. Invalid context');
                localStorage.removeItem('session');
                return false;
            }

            function currentMBUserId() {
                var session = getSession();

                return session ? session.preferences.id : null;
            }

            function getPreferredName() {
                var session = getSession();

                return session ? session.preferences.preferredName : null;
            }

            function currentUserId() {
                var session = getSession();

                return session ? session.username : null;
            }

            function getCustomerId() {
                var session = getSession();

                return session ? session.customerId : null;
            }

            function currentCompany() {
                // if opening new tab from a link
                if (!sessionStorage.getItem('company')) {
                    sessionStorage.setItem('company', localStorage.getItem('company'));
                }

                return hasValidContext() && sessionStorage.getItem('company')
                    ? JSON.parse(sessionStorage.getItem('company'))
                    : null;
            }

            function currentCompanyId() {
                var company = currentCompany();
                return company ? company.businessKey : null;
            }

            function userPrivileges() {
                var company = currentCompany();
                return company ? company.userPrivileges : null;
            }

            function hasEntitlement(entitlement) {
                if (userPrivileges()
                    && userPrivileges().entitlements
                    && userPrivileges().entitlements[entitlement] == 'YES') {
                    return true;
                }
                return false;
            }

            // Store entitlements in local storage to be accessible by all tabs
            function setCompany(company) {
                var deferred = $q.defer();
                $http.get(config.userValidateEndpoint, {
                    data: {
                        userId: currentUserId(),
                        companyId: company.businessKey
                    }
                }).success(function (response) {
                    company.entitlements = response;
                    company.userPrivileges = response.userPrivileges;
                    sessionStorage.setItem('company', JSON.stringify(company));
                    localStorage.setItem('company', JSON.stringify(company));
                    sessionStorage.setItem('companyId', company.businessKey);
                    deferred.resolve(company);
                }).error(function (err) {
                    deferred.reject(err.errorCode || 500);
                });

                return deferred.promise;
            }

            function actionKey(type) {
                return currentCompanyId() + '-' + type;
            }


            function setAction(action) {
                if (action.context.company) {
                    setCompany(action.context.company).then(function () {
                        localStorage.setItem(actionKey(action.type), JSON.stringify(action));
                        if (action.redirectTo) {
                            window.location.href = window.b$.portal.config.serverRoot + '/' + action.redirectTo;
                        }
                    });
                } else {
                    localStorage.setItem(actionKey(action.type), JSON.stringify(action));
                    if (action.redirectTo) {
                        window.location.href = window.b$.portal.config.serverRoot + '/' + action.redirectTo;
                    }
                }
            }


            /**
             * Actions are specific per company
             * @param type
             */
            function getAction(type) {
                var key = actionKey(type);
                var actionString = localStorage.getItem(key);

                return actionString
                    ? JSON.parse(actionString)
                    : null;
            }


            /**
             * Actions are specific per company
             * @param type
             */
            function removeAction(type) {
                var key = actionKey(type);
                localStorage.removeItem(key);
            }


            function hasMultipleCompanies() {
                var session = getSession();

                return !!session && session.companies.data.length > 1;
            }

            function hasAnyApprovalLevel() {
                var session = getSession();
                if (!session) {
                    return false;
                }
                var approvalLevels = session.approvalLevels;

                for (var key in approvalLevels) {
                    if (approvalLevels.hasOwnProperty(key) && approvalLevels[key] === 'AUTHORISE') {
                        return true;
                    }
                }
                return false;
            }

            function hasAnyVerificationLevel() {
                var session = getSession();
                if (!session) {
                    return false;
                }
                var approvalLevels = session.approvalLevels;
                for (var key in approvalLevels) {
                    if (approvalLevels.hasOwnProperty(key) && approvalLevels[key] === 'VERIFY') {
                        return true;
                    }
                }
                return false;
            }

            return {
                hasValidContext: hasValidContext,
                currentCompanyId: currentCompanyId,
                currentCompany: currentCompany,
                currentUserId: currentUserId,
                setCompany: setCompany,
                setAction: setAction,
                getAction: getAction,
                removeAction: removeAction,
                hasMultipleCompanies: hasMultipleCompanies,
                getSession: getSession,
                userPrivileges: userPrivileges,
                hasEntitlement: hasEntitlement,
                currentMBUserId: currentMBUserId,
                getPreferredName: getPreferredName,
                getCustomerId: getCustomerId,
                hasAnyApprovalLevel: hasAnyApprovalLevel,
                hasAnyVerificationLevel: hasAnyVerificationLevel
            };
        };

    };


});



// WEBPACK FOOTER //
// ./scripts/services/metroContextService.js